import React from 'react';
import { Query } from 'react-apollo';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import { CURRENT_USER } from '../graphql';
import Header from '../components/Header';
import FullLayout from '../components/FullLayout';
import PleaseWait from '../components/PleaseWait';
import { RotatingText } from './components/RotatingText';

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  align-self: center;
`;

const withSession = (Component, b) => (props) => {
  // console.log({b})
  return (
    <Query query={CURRENT_USER} notifyOnNetworkStatusChange>
      {({ data, loading, refetch, error }) => {
        if (loading) {
          if (b && b.transparentBg) {
            return (
              <FullLayout
                hideBubbles
                style={{
                  backgroundColor: 'transparent',
                }}
              >
                <Container>
                  <Flex flex={1}>
                    <Header dark={false} />
                  </Flex>
                  <PleaseWait
                    text=" "
                    spinner={{
                      sColor: '#ECEFF2',
                      pColor: '#909FB5',
                    }}
                  >
                    <RotatingText />
                  </PleaseWait>
                </Container>
              </FullLayout>
            );
          }
          if (b && b.loadingScreen) {
            return b.loadingScreen;
          }

          return (
            <FullLayout style={(b || {}).wrapperStyle}>
              <Container>
                <Flex flex={1}>
                  <Header dark={false} />
                </Flex>
                <PleaseWait
                  text=" "
                  spinner={{
                    sColor: '#ECEFF2',
                    pColor: '#909FB5',
                  }}
                >
                  <RotatingText />
                </PleaseWait>
              </Container>
            </FullLayout>
          );
        }
        if (error) {
          if (error) {
            console.log('err curr', error);
          }
          return null;
        }
        return (
          <Component
            {...props}
            session={data.currentUser}
            refetch={() => {
              refetch();
            }}
          />
        );
      }}
    </Query>
  );
};

export default withSession;
